import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MenuAppsAPI from '../../api/menuApps';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  allMenuApps(_state) {
    return [..._state.records].sort(
      (a, b) => (a.position ?? 0) - (b.position ?? 0)
    );
  },
};

export const actions = {
  fetch: async function fetchMenuApps({ commit }) {
    commit(types.SET_MENU_APPS_UI_FLAG, { isFetching: true });
    try {
      const response = await MenuAppsAPI.get();
      commit(types.SET_MENU_APPS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MENU_APPS_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createMenuApp({ commit }, appObj) {
    commit(types.SET_MENU_APPS_UI_FLAG, { isCreating: true });
    try {
      const response = await MenuAppsAPI.create(appObj);
      commit(types.CREATE_MENU_APP, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MENU_APPS_UI_FLAG, { isCreating: false });
    }
  },
  update: async function updateMenuApp({ commit }, { id, ...updateObj }) {
    commit(types.SET_MENU_APPS_UI_FLAG, { isUpdating: true });
    try {
      const response = await MenuAppsAPI.update(id, updateObj);
      commit(types.EDIT_MENU_APP, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MENU_APPS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async function deleteMenuApp({ commit }, id) {
    commit(types.SET_MENU_APPS_UI_FLAG, { isDeleting: true });
    try {
      await MenuAppsAPI.delete(id);
      commit(types.DELETE_MENU_APP, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MENU_APPS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_MENU_APPS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_MENU_APPS]: MutationHelpers.set,
  [types.CREATE_MENU_APP]: MutationHelpers.create,
  [types.EDIT_MENU_APP]: MutationHelpers.update,
  [types.DELETE_MENU_APP]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
